import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Table from '@components/table';
import LegendModal from '@awp/components/dataTables/LegendModal';
import { Permissions } from '@awp/constants';
import { hasAccess } from '@awp/components/Authorize';
import { prepareTable } from '@awp/components/dataTables/helpers/dataProcess';

const TableView = ({
  selectedDatasets,
  id,
  showInvalidData,
  showConfidenceLevel,
  showValidData,
  doubleClickHandler,
  pageSize,
  tableParentClasses,
  paginationBarClasses,
}) => {
  const [legend, setLegend] = useState([]);
  const [index, setIndex] = useState(0);
  const [sort, setSort] = useState([{ id: 'Timestamp', desc: true }]);
  const [defaultPageSize, setDefaultPageSize] = useState(!pageSize ? 25 : pageSize);
  const [maxHeight, setMaxHeight] = useState(0);
  const hasWriteDataTableManualValidation = hasAccess([Permissions.WriteDataTableManualValidation]);

  useEffect(() => {
    const calculateMaxHeight = () => {
      const height = Math.round(window.innerHeight * 0.85);
      setMaxHeight(height);
    };

    calculateMaxHeight();

    window.addEventListener('resize', calculateMaxHeight);

    return () => {
      window.removeEventListener('resize', calculateMaxHeight);
    };
  }, []);

  const { tableData, tableColumns } = prepareTable(
    selectedDatasets,
    {
      showInvalidData,
      showConfidenceLevel,
      showValidData,
    },
    'data-tables',
  );

  if (!selectedDatasets || selectedDatasets.length === 0) return <></>;

  const showLegend = (e, cell) => {
    setLegend(cell?.column?.legend);
  };

  return (
    <>
      <Table
        columns={tableColumns}
        data={tableData}
        fetchData={() => {}}
        loading={false}
        filters={[]}
        isFirstColumnSticky={true}
        doubleClickHandler={hasWriteDataTableManualValidation ? doubleClickHandler : () => {}}
        onClickHandler={showLegend}
        key={`tbl-${id}`}
        index={index}
        setIndex={setIndex}
        sort={sort}
        setSort={setSort}
        defaultPageSize={defaultPageSize}
        setDefaultPageSize={setDefaultPageSize}
        tableParentClasses={tableParentClasses}
        paginationBarClasses={paginationBarClasses}
        maxHeight={maxHeight}
        autoHide={true}
      />
      <LegendModal legend={legend} setLegend={setLegend} />
    </>
  );
};

TableView.propTypes = {
  selectedDatasets: PropTypes.array,
  id: PropTypes.number.isRequired,
  showInvalidData: PropTypes.bool,
  showConfidenceLevel: PropTypes.bool,
  showValidData: PropTypes.bool,
  doubleClickHandler: PropTypes.func,
  pageSize: PropTypes.number,
};

export default TableView;
